import { useQuery } from "react-query";
import getVirtualAccounts, {
  VirtualAccountRequest,
} from "../services/getVirtualAccounts";
function useGetVirtualAccounts(
  params: VirtualAccountRequest,
  enabled: boolean = true
) {
  return useQuery(
    ["get-vaacounts", params],
    () =>
      getVirtualAccounts({
        ...params,
      }),
    {
      retry: false,
      enabled,
    }
  );
}

export default useGetVirtualAccounts;
